import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import AssessmentEntry from "./AssessmentEntry";
import classes from './AssessmentTable.module.css'

const AssessmentTable = ({ filteredlist, allSubmissions, currentTab, setCurrentTab }) => {
    const direction = useSelector(state => state.translate.direction);
    const texts = useSelector(state => state.translate.texts);
    const [sortField, setSortField] = useState("submittedDate");
    const titleRow = useMemo(() => { return { "assessmentName": texts.assessment, "submittedDate": texts.submissionDate, "statusChangedDate": texts.statusChangedDate, "score": texts.score, "submittedByUser": texts.team } }, [texts])

    const handleTabs = (index) => {
        setCurrentTab(index)
        switch (index) {
            case 1: setSortField("createdDate");
                break;
            case 2: setSortField("statusChangedDate");
                break;
            default: setSortField("submittedDate");
                break;
        }
    }

    return (
        <div className={`${classes.ScrollBar} ${classes[direction]}`}>
            <div className={classes.Table}>

                <div className={classes.BtnsContainer}>
                    {allSubmissions.map((btn, index) =>
                        <button key={index} className={`${classes.Btn} ${currentTab === index ? classes.CurrentBtn : ''}`} onClick={() => handleTabs(index)}>
                            {btn.name}{allSubmissions[index].numTab > 0 && `(${allSubmissions[index].numTab}) `}
                        </button>
                    )}
                </div>
                {allSubmissions[currentTab].comment && <div className={classes.Title}>{texts.waitingForYou} {allSubmissions[currentTab].numTab} {allSubmissions[currentTab].comment}</div>}

                {filteredlist.length > 0 && <AssessmentEntry row={titleRow} title={true} currentTab={currentTab} />}
                {(filteredlist && filteredlist.length > 0) && [].concat(filteredlist).sort((a, b) => a[sortField] < b[sortField] ? 1 : -1).map((a, i) =>
                    <AssessmentEntry row={a} key={i} index={i} currentTab={currentTab} />)
                }
            </div>
        </div >
    )
}

export default AssessmentTable;